/** Prefix https:// when missing so browsers do not treat host-like strings as same-origin paths. */
export function ensureAbsoluteUrl(url: string | null | undefined): string | null {
  const s = (url ?? '').trim()
  if (!s) return null
  if (s.startsWith('http://') || s.startsWith('https://')) return s
  return `https://${s}`
}
